import { LDContext } from "@launchdarkly/react-sdk";
import { IUserModel } from "../hooks/useAuthentication";

type FeatureFlagUser = Pick<IUserModel, "role"> & { id?: number };

const ANONYMOUS_USER_KEY = "anonymous";

// Keep the keys and attribute names in sync with the API's FeatureFlagContextBuilder.cs,
// otherwise a flag targeted in LaunchDarkly resolves differently in the SPA and in the API.
const buildUserAttributes = (user?: FeatureFlagUser | null) => {
  if (!user?.id) {
    // Same fixed key as the API, so anonymous targeting resolves identically in both.
    return { key: ANONYMOUS_USER_KEY, anonymous: true };
  }

  return {
    key: String(user.id),
    ...(user.role ? { role: user.role } : {}),
  };
};

export const buildFeatureFlagContext = (
  user: FeatureFlagUser | null | undefined,
  selectedStudioId: number
): LDContext => {
  const userAttributes = buildUserAttributes(user);

  if (!(selectedStudioId > 0)) {
    return { kind: "user", ...userAttributes };
  }

  return {
    kind: "multi",
    user: userAttributes,
    studio: { key: String(selectedStudioId) },
  };
};
